import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import parse from "html-react-parser";

import authHeader from '../../../helpers/authHeader';
import { handleResponse } from '../../../helpers/handleResponse';
import { alphabetArray } from '../../../helpers/utils';
import { selectShow } from '../../../redux/modals/modal.select';
import { toggleShow } from '../../../redux/modals/modals.actions';
import FooterComponent from '../../Common/footer/footer.component';


import {
    Table, 
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@material-ui/core';

import { 
    BarChart, 
    Bar, 
    XAxis, 
    YAxis, 
    Tooltip, 
    Cell 
} from 'recharts';

import './ResultsTable.css';


const ResultsTable = ({ classPeriod, className, quizId, previewQuizId, quizName, show, toggleShow }) => {

    const API_URL = process.env.REACT_APP_API_URL;
    const history = useHistory();

    const [data, setData] = useState([])
    const [questions, setQuestions] = useState(null)
    const fetchData = () => {
        const requestOptions = {
            method: "GET",
            headers: authHeader(),
            credentials: "include",
        };
        fetch(API_URL + `/classqzresult/${quizId}/result/`, requestOptions)
            .then(
                handleResponse
            )
            .then(
                (data) => {
                    if (data && data.status_code !== 400) {
                        setData(data)
                    } else {
                        setData(null);
                    }
                })
        // .then((data) => setData(data))
    }

    const fetchQuizPreview = (quizId) => {
        const requestOptions = {
            method: "GET",
            headers: authHeader(),
            credentials: "include",
        };
        fetch(API_URL + `/quiz/${quizId}/`, requestOptions)
            .then(
                handleResponse
            )
            .then((data) => {
                setQuestions(data.questions)
            })
    }

    useEffect(() => {
        fetchData();
        fetchQuizPreview(previewQuizId)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const firstRow = data && data.no_errors ? data?.no_errors : {};
    const answerRow = data && data.result ? Object.values(data?.result) : []; 
    

    const tableView = (
        <div className='results-container'>
            <div className='back-results'>
                <button 
                    className='back-button-results'
                    onClick={() => history.push(`/class-quizzes/${classPeriod}/${className}`)}
                >
                    BACK TO QUIZZES
                </button>
                <h1 style={{textAlign:'left', fontSize: '42px', fontWeight: 'normal'}}>{quizName ?? ''}</h1>
                <h5>Students with No Errors</h5>
                <ol>
                    {firstRow && firstRow.no_errors_count && firstRow.no_errors_data.length ? firstRow.no_errors_data.map(item => 
                        <li>{item.name}</li>
                    ) : <p>No Students with all Questions Correct</p>}
                </ol>
            </div>
            

            <TableContainer className="results-table-container">
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" style={{ fontWeight: 'bold', color: 'black', fontSize: '30px', width: 195 }}>
                                Question #
                            </TableCell>
                            <TableCell align="center" style={{ fontWeight: 'bold', color: 'black', fontSize: '30px' }}>
                                {' '}
                                Question & Ans{' '}
                            </TableCell>
                            <TableCell align="center" style={{ fontWeight: 'bold', color: 'black', fontSize: '30px', width: 240 }}>
                                {' '}
                                Answer Selections{' '}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {answerRow.length ? (
                            answerRow.map((item, index) => {
                                var myData = Object.keys(item).map(key => {
                                    return item[key];
                                });

                                var studentAnswers = 0;
                                myData && myData.map(it => (studentAnswers += it.nAnswers));

                                const currentQuestion = questions && questions[index];

                                return (
                                    <TableRow key={index}>
                                        <TableCell align="center" style={{ width: 60, padding: '16px' }} className="question-row">
                                            <span style={{ fontWeight: 'bold' }}>{index + 1}</span>
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ borderBottom: '2px solid grey', position: 'relative', padding: '16px' }}
                                            className="standard"
                                        >
                                            <div style={{ display: 'flex', gap: '45px', justifyContent: 'center' }}>
                                                <div style={{ textAlign: 'left', fontSize: '16px' }}>
                                                    <p style={{ marginBottom: '8px' }}>
                                                        {currentQuestion
                                                            ? parse(currentQuestion.question.value)
                                                            : `Question ${index + 1}`}
                                                    </p>
                                                    {currentQuestion &&
                                                        currentQuestion.question.answers.map((ans, ansIndex) => {
                                                            return ans.correct === true ? (
                                                                <ul
                                                                    key={ansIndex}
                                                                    style={{
                                                                        fontWeight: 'bold',
                                                                        paddingLeft: 0,
                                                                        marginBottom: '4px'
                                                                    }}
                                                                >
                                                                    {`${alphabetArray[ansIndex]} ${ans.content}`}
                                                                </ul>
                                                            ) : (
                                                                <ul
                                                                    key={ansIndex}
                                                                    style={{ paddingLeft: 0, marginBottom: '4px' }}
                                                                >
                                                                    {`${alphabetArray[ansIndex]} ${ans.content}`}
                                                                </ul>
                                                            );
                                                        })}
                                                </div>
                                                <div
                                                    className="standard-hover-container"
                                                    style={{ paddingTop: '4px', alignSelf: 'end' }}
                                                >
                                                    <span
                                                        style={{
                                                            color: '#1976d2',
                                                            textDecoration: 'underline',
                                                            cursor: 'help',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        Standards
                                                    </span>
                                                    <div className="standard-tooltip">
                                                        <strong>{item[0].standard_code}</strong>
                                                        <p style={{ margin: '8px 0 0 0' }}>{item[0].standard_brief}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </TableCell>
                                        <TableCell
                                            align="center"
                                            style={{ borderBottom: '2px solid grey' }}
                                            className="bar-chart"
                                        >
                                            <BarChart
                                                width={400}
                                                height={200}
                                                data={myData}
                                                margin={{
                                                    top: 5,
                                                    left: 10,
                                                    bottom: 5
                                                }}
                                                barSize={20}
                                            >
                                                <XAxis dataKey="label" scale="point" padding={{ left: 10, right: 10 }} />
                                                <YAxis allowDecimals={false} tickCount={studentAnswers + 1} />

                                                <Tooltip />

                                                <Bar dataKey="nAnswers">
                                                    {myData &&
                                                        myData.map(it => <Cell fill={it.correct === true ? 'green' : 'grey'} />)}
                                                </Bar>
                                            </BarChart>
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                            
                        ) : (
                            <p style={{ color: 'grey', marginTop: 30, textAlign: 'center' }}>
                                There are no results at this moment.
                            </p>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <div className='results-footer'>
                <FooterComponent />
            </div>
        </div>
    );

    return tableView;
};

const mapStateToProps = createStructuredSelector({
    show: selectShow,
});

const mapDispatchToProps = (dispatch) => {
    return {
        toggleShow: () => dispatch(toggleShow()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultsTable);
